/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 6962b7b3d941
 */

import * as z from "zod";
import {
  StreamingProfile,
  StreamingProfile$zodSchema,
} from "./streamingprofile.js";

export type StreamingProfileUpdateResponse = {
  message: string;
  data: StreamingProfile;
};

export const StreamingProfileUpdateResponse$zodSchema: z.ZodType<
  StreamingProfileUpdateResponse
> = z.object({
  data: StreamingProfile$zodSchema,
  message: z.string(),
});
